import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

const serviceAreas = [
  { name: "Surprise", slug: "surprise" },
  { name: "Glendale", slug: "glendale" },
  { name: "Peoria", slug: "peoria" },
  { name: "Goodyear", slug: "goodyear" },
  { name: "Buckeye", slug: "buckeye" },
  { name: "Avondale", slug: "avondale" },
  { name: "Sun City", slug: "sun-city" },
  { name: "El Mirage", slug: "el-mirage" },
  { name: "Waddell", slug: "waddell" },
  { name: "Wittmann", slug: "wittmann" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          <div>
            <div className="mb-4">
              <img src={logo} alt="Valley Sun Screens — Phoenix sun screen installation company" className="h-32 w-auto" loading="lazy" decoding="async" />
            </div>
            <p className="text-background/70 leading-relaxed mb-6">
              Phoenix's trusted sun screen installation company. Keeping Arizona homes cool, comfortable, and energy-efficient since 2023.
            </p>
            <div className="space-y-2 text-background/80">
              <a href="tel:+16233014595" className="flex items-center gap-2 hover:text-sun-yellow transition-colors">
                <Phone className="w-4 h-4" /> (623) 301-4595
              </a>
              <a href="mailto:info@valleysunscreens.com" className="flex items-center gap-2 hover:text-sun-yellow transition-colors">
                <Mail className="w-4 h-4" /> info@valleysunscreens.com
              </a>
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4" /> Phoenix, AZ
              </span>
              <span className="flex items-center gap-2">
                ROC #359560
              </span>
            </div>
          </div>

          <nav aria-label="Quick links">
            <h3 className="font-heading font-black text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-background/70">
              <li><Link to="/instant-quote" className="hover:text-sun-yellow transition-colors">Instant Quote</Link></li>
              <li><Link to="/#services" className="hover:text-sun-yellow transition-colors">Services</Link></li>
              <li><Link to="/#benefits" className="hover:text-sun-yellow transition-colors">Benefits</Link></li>
              <li><Link to="/#how-it-works" className="hover:text-sun-yellow transition-colors">How It Works</Link></li>
              <li><Link to="/screen-options" className="hover:text-sun-yellow transition-colors">Screen Options</Link></li>
              <li><Link to="/maintenance" className="hover:text-sun-yellow transition-colors">Maintenance Plans</Link></li>
              <li><Link to="/warranty" className="hover:text-sun-yellow transition-colors">Warranty</Link></li>
              <li><Link to="/#faq" className="hover:text-sun-yellow transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-sun-yellow transition-colors">Contact</Link></li>
              <li><Link to="/areas" className="hover:text-sun-yellow transition-colors">All Service Areas</Link></li>
              <li><Link to="/privacy" className="hover:text-sun-yellow transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-sun-yellow transition-colors">Terms &amp; Conditions</Link></li>
              <li><a href="/sitemap.xml" className="hover:text-sun-yellow transition-colors">Sitemap</a></li>
            </ul>
          </nav>

          <nav aria-label="Service areas">
            <h3 className="font-heading font-black text-lg mb-4">Service Areas</h3>
            <div className="flex flex-wrap gap-2">
              {serviceAreas.map((area) => (
                <Link
                  key={area.slug}
                  to={`/areas/${area.slug}`}
                  className="bg-background/10 rounded-full px-3 py-1 text-sm text-background/80 hover:bg-background/20 hover:text-sun-yellow transition-colors"
                >
                  {area.name}
                </Link>
              ))}
            </div>
          </nav>
        </div>

        <div className="border-t border-background/15 pt-8 text-center text-background/50 text-sm space-y-1">
          <p>© {new Date().getFullYear()} Valley Sun Screens. All rights reserved. Licensed & Insured in Arizona.</p>
          <p className="text-background/60 italic text-xs">A <span className="font-bold not-italic">Vivid Services</span> Company</p>
        </div>
      </div>
    </footer>
  );
}
